import React, { useState } from "react";
import { APIEndpoints } from "../constants/APIEndpoints";
import BaseClient from "../helper/Baseclient";

const useHolidays = () => {
  const [holidaysLoading, setHolidaysLoading] = useState(false);
  const [holidaysList, setHolidaysList] = useState(null);
  const [upComingHolidays, setUpcomingholidays] = useState(null);

  const getAllholidays = async (token) => {
    try {
      setHolidaysLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      await BaseClient.get(
        APIEndpoints.fetchHolidaysList,
        {},
        {
          onSuccess: (res) => {
            if (res.status == true) {
              setHolidaysList(res?.data);
              return;
            }
          },
          onFailed: (err) => {
            console.log("Holidays list error", err);
          },
          headers: headers,
        }
      );
    } finally {
      setHolidaysLoading(false);
    }
  };

  const getUpcomingHolidaysList = async (token) => {
    try {
      setHolidaysLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      await BaseClient.get(
        APIEndpoints.fetchUpcomingHolidays,
        {},
        {
          onSuccess: (res) => {
            if (res.status == true) {
              setUpcomingholidays(res?.data);
              return;
            }
          },
          onFailed: (err) => {
            console.log("Holidays list error", err);
          },
          headers: headers,
        }
      );
    } finally {
      setHolidaysLoading(false);
    }
  };

  const createNewHoliday = async (
    payload,
    { onSuccess, onFailed, headers }
  ) => {
    try {
      setHolidaysLoading(true);

      await BaseClient.post(APIEndpoints.createNewHoliday, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setHolidaysLoading(false);
    }
  };

  const removeHolidaySingle = async (id, { onSuccess, onFailed, headers }) => {
    try {
      setHolidaysLoading(true);

      await BaseClient.delete(APIEndpoints.deleteSingleHoliday + `/${id}`, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setHolidaysLoading(false);
    }
  };

  return {
    getAllholidays,
    holidaysList,
    getUpcomingHolidaysList,
    upComingHolidays,
    holidaysLoading,
    createNewHoliday,
    removeHolidaySingle,
  };
};

export default useHolidays;
